<div #passButtonsContainer>
	<app-create-pass-button
		[title]="screenService.windowWidth < screenService.largeDevicesBreakPoint ? '' : 'Schedule Pass'"
		(onClick)="showScheduleForm()"
		[width]="screenService.isDeviceLarge ? '51px' : ''"
		[icon]="screenService.windowWidth < screenService.largeDevicesBreakPoint ? 'Clock (Gray).svg' : ''">
	</app-create-pass-button>
</div>
